var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.studios && _vm.studios.length > 0)?_c('studio'):_vm._e(),_c('creativeagency')],1)}
var staticRenderFns = []

export { render, staticRenderFns }